// reducers/index.js
import { combineReducers } from 'redux';
import citiesReducer from '../redux/reducers/citiesReducer';
import statesReducer from '../redux/reducers/statesReducer';
import higherEducationReducer from '../redux/reducers/higherEducationReducer';
import formReducer from './reducers/formReducer';
import adminReducer from './reducers/adminReducer';
import studentReducer from './reducers/studentReducer'
import emailReducer from './reducers/emailReducer';
import emailStatusReducer from './reducers/emailStatusReducer';
import { updateStudent } from './reducers/UpdateStudent.js';
import { UploadState } from './reducers/UploadState.js';
import { updateState } from './reducers/UpdateState.js';
import FetchStateById from './reducers/FetchStateById.js';
import DeactivateState from './reducers/DeactivateState.js';

import { FetchCity } from './reducers/FetchCity.js';
import { UploadCity } from './reducers/UploadCity.js';
import { updateCity } from './reducers/UpdateCity.js';
import FetchCityById from './reducers/FetchCityById.js';
import DeactivateCity from './reducers/DeactivateCity.js';

import { UploadEducation } from './reducers/UploadEducation.js';
import { updateEducation } from './reducers/UpdateEducation.js';
import FetchEducationById from './reducers/FetchEducationById.js';
import DeactivateEducation from './reducers/DeactivateEducation.js';
import userSubmitReducer from './reducers/userSubmitReducer';
import rolesReducer from './reducers/rolesReducer';
import userdisplayReducer from './reducers/userdisplayReducer';
import { FetchMark } from './reducers/FetchQualified.js';
import { UploadMark } from './reducers/UploadMark.js';
import { FetchStudentMark } from './reducers/FetchStudentMark.js';
import userEmailReducer from './reducers/userEmailReducer.js';
import { EmailMark } from './reducers/EmailMark.js';
import { UploadPayment } from './reducers/UploadPayment.js';
import { FetchStudent } from './reducers/FetchTotalStudents.js';
import { UploadEmailPopup } from './reducers/UploadEmailPopup.js';
import DeactivateStudent from './reducers/DeactivateStudent.js';
import DeactivateQualifiedStudent from './reducers/DeactivateQualifiedStudent.js';
import DeactivateRole from './reducers/DeactivateRole.js';
import { UploadRole } from './reducers/UploadRole.js';
import eventReducer from './reducers/eventReducer.js';
import UploadForgotPassword from './reducers/UploadForgotPassword.js';
import UploadOtpReducer from './reducers/UploadOtpReducer.js';
import UpdatePasswordReducer from './reducers/UpdatePasswordReducer.js';
import FetchEventById from './reducers/FetchEventById.js';
import { UploadParticipant } from './reducers/UploadParticipantRegistrationForm.js';
import { FetchParticipants } from './reducers/FetchParticipants.js';
import EditUserReducer from './reducers/EditUserReducer.js'
//import EditUserReducer from './reducers/EditUserReducer.js';
import { EmailEvent } from './reducers/emailEvent.js';
//import DeactivateUserReducer from './reducers/DeactivateUserReducer.js';
import {feedbackFormReducer} from './reducers/feedbackReducer.js';
import { FetchFeedback } from './reducers/FetchFeedback.js';
import { FetchCertificate } from './reducers/FetchCertificate.js';
import { FetchAllCertificate } from './reducers/FetchAllCertificate.js';
import UploadCountdownReducer from './reducers/UploadCountdownReducer.js';
import UploadEventReducer from './reducers/UploadEventReducer.js';
import { UploadEventImage } from './reducers/UploadEventImage.js';
import { UploadMentorImage } from './reducers/UploadMentorImage.js';
import { UploadJudgeImage } from './reducers/UploadJudgeImage.js';
import { UploadSponsorImage } from './reducers/UploadSponsorImage.js';
import FetchEventImage from './reducers/FetchEventImage.js';
import UploadlatestconferenceReducer from './reducers/UploadlatesteconferenceReducer.js';
import UploadlatestwebinarReducer from './reducers/UploadlatestwebinarReducer.js';
import UploadlatestworkshopReducer from './reducers/UploadlatestworkshopReducer.js'
import collaborationReducer from './reducers/collaborationReducer.js';
import FetchCollaborationImage from './reducers/FetchCollaborationImage.js';
import { UploadCollaborationImage } from './reducers/UploadCollaborationImage.js';
//import { fetchTotalCollaborations } from './actions/action.js';
import  uploadBlog  from './reducers/uploadBlog.js';
import  hackathonFormReducer from './reducers/hackathonFormReducer';
import FetchHackathons from './reducers/FetchTotalHackathons.js';
import FetchMentors from './reducers/FetchTotalMentors.js';
import FetchJudges from './reducers/FetchTotalJudges.js';
import FetchSponsors from './reducers/FetchTotalSponsors.js';
import FetchPrizes from './reducers/fetchTotalprizes.js';
import FetchAgendas from './reducers/fetchTotalAgendas.js';
import fetchAllAgendasReducer from './reducers/fetchAllAgendasReducer.js';

import { UploadBlogImage } from './reducers/UploadBlogImage.js';
import blogImageReducer from './reducers/FetchBlogImage.js';  
import AddUserMangFormReducer  from './reducers/AddUserMangFormReducer.js';
import passwordResetReducer from './reducers/passwordResetReducer.js';


//// Combine all the reducers

const rootReducer = combineReducers({
  HackathonForm:hackathonFormReducer,// Your hackathon-related data will be stored here
  states: statesReducer,
  cities: citiesReducer,
  higherEducation: higherEducationReducer,
  form: formReducer,
  admin: adminReducer,
  students: studentReducer,
  email: emailReducer,
  emailstatus: emailStatusReducer,
  updateStudent: updateStudent,
  fetchStateById: FetchStateById,
  uploadState: UploadState,
  updateState: updateState,
  deactivateState: DeactivateState,

  fetchCity: FetchCity,
  fetchCityById: FetchCityById,
  uploadCity: UploadCity,
  updateCity: updateCity,
  deactivateCity: DeactivateCity,

  fetchEducationById: FetchEducationById,
  uploadEducation: UploadEducation,
  updateEducation: updateEducation,
  deactivateEducation: DeactivateEducation,
  userForm:userSubmitReducer,
  roles:rolesReducer,
  users:userdisplayReducer,
  fetchMark: FetchMark,
  uploadMark: UploadMark,
  fetchStudentMark: FetchStudentMark,
  userEmail:userEmailReducer,
  emailMark: EmailMark,
  uploadPayment: UploadPayment,
  fetchStudent: FetchStudent,
  uploadEmailPopup:UploadEmailPopup,
  deactivateStudent: DeactivateStudent,
  deactivateQualifiedStudent: DeactivateQualifiedStudent,
  deactivateRole: DeactivateRole,
  uploadRole: UploadRole,
  events:eventReducer,
  uploadForgotPassword:UploadForgotPassword,
  uploadOtp:UploadOtpReducer,
  uploadResetPassword:UpdatePasswordReducer,
  fetchEventById: FetchEventById,
  uploadParticipant: UploadParticipant,
  fetchParticipants: FetchParticipants,
  edituser:EditUserReducer,
  emailEvent: EmailEvent,
  // deactivateuser:DeactivateUserReducer
  feedback: feedbackFormReducer,
  fetchFeedback: FetchFeedback,
  fetchCertificate: FetchCertificate,
  fetchAllCertificate: FetchAllCertificate,
  uploadcountdown:UploadCountdownReducer,
  uploadevent:UploadEventReducer,
  uploadEventImage:UploadEventImage,
  fetcheventimage:FetchEventImage,
  latestconference:UploadlatestconferenceReducer,
  latestwebinar:UploadlatestwebinarReducer,
  latestworkshop:UploadlatestworkshopReducer,
  collaboration:collaborationReducer,
 fetchcollaborationimage:FetchCollaborationImage,
 uploadCollaborationimage:UploadCollaborationImage,
 collaborationsState: collaborationReducer,

 uploadBlog:uploadBlog,
 uploadMentorImage:UploadMentorImage,
 UploadJudgeImage:UploadJudgeImage,
 UploadSponsorImage:UploadSponsorImage,

 hackathons:FetchHackathons,
 mentors:FetchMentors,
 judges:FetchJudges,
 sponsors:FetchSponsors,
 prizes:FetchPrizes,
agenda:FetchAgendas,
fetchAllAgendas: fetchAllAgendasReducer,

uploadBlogImage:UploadBlogImage, 
 blogReducer:blogImageReducer,
passwordResetReducer:passwordResetReducer,
AddUserMangFormReducer:AddUserMangFormReducer,



 //register: registerUserReducer,


});

export default rootReducer;
